import * as e from "react";
import i from "../lib/IconBase.es.js";
import n from "../defs/IdentificationBadge.es.js";
const o = e.forwardRef((t, a) => /* @__PURE__ */ e.createElement(i, { ref: a, ...t, weights: n }));
o.displayName = "IdentificationBadgeIcon";
const d = o;
export {
  d as IdentificationBadge,
  o as IdentificationBadgeIcon
};
